import { render } from "./QYYS.vue?vue&type=template&id=7f2a4119"
import script from "./QYYS.vue?vue&type=script&lang=js"
export * from "./QYYS.vue?vue&type=script&lang=js"

import "./QYYS.vue?vue&type=style&index=0&id=7f2a4119&lang=scss"

import exportComponent from "D:\\大众物流官网\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__